const _excluded = ["children", "indicators", "leftControl", "rightControl", "slide", "slideInterval", "className", "theme"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Children, cloneElement, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';
import ScrollContainer from 'react-indiana-drag-scroll';
import { useTheme } from '../../';
import { isClient } from '../../helpers/is-client';
import { mergeDeep } from '../../helpers/merge-deep';
export const Carousel = _ref => {
  let children = _ref.children,
    _ref$indicators = _ref.indicators,
    indicators = _ref$indicators === void 0 ? true : _ref$indicators,
    leftControl = _ref.leftControl,
    rightControl = _ref.rightControl,
    _ref$slide = _ref.slide,
    slide = _ref$slide === void 0 ? true : _ref$slide,
    slideInterval = _ref.slideInterval,
    className = _ref.className,
    _ref$theme = _ref.theme,
    customTheme = _ref$theme === void 0 ? {} : _ref$theme,
    props = _objectWithoutProperties(_ref, _excluded);
  const theme = mergeDeep(useTheme().theme.carousel, customTheme);
  const isDeviceMobile = isClient() && navigator.userAgent.indexOf('IEMobile') !== -1;
  const carouselContainer = useRef(null);
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeItem = _useState2[0],
    setActiveItem = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDragging = _useState4[0],
    setIsDragging = _useState4[1];
  const items = useMemo(() => Children.map(children, child => /*#__PURE__*/cloneElement(child, {
    className: classNames(theme.item.base, child.props.className)
  })), [children, theme.item.base]);
  const navigateTo = useCallback(item => () => {
    if (!items) return;
    item = (item + items.length) % items.length;
    if (carouselContainer.current) {
      carouselContainer.current.scrollLeft = carouselContainer.current.clientWidth * item;
    }
    setActiveItem(item);
  }, [items]);
  useEffect(() => {
    if (carouselContainer.current && !isDragging && carouselContainer.current.scrollLeft !== 0) {
      setActiveItem(Math.round(carouselContainer.current.scrollLeft / carouselContainer.current.clientWidth));
    }
  }, [isDragging]);
  useEffect(() => {
    if (slide) {
      const intervalId = setInterval(() => !isDragging && navigateTo(activeItem + 1)(), slideInterval !== null && slideInterval !== void 0 ? slideInterval : 3000);
      return () => clearInterval(intervalId);
    }
  }, [activeItem, isDragging, navigateTo, slide, slideInterval]);
  const handleDragging = dragging => () => setIsDragging(dragging);
  return _jsxs("div", _objectSpread(_objectSpread({
    className: classNames(theme.root.base, className),
    "data-testid": "carousel"
  }, props), {}, {
    children: [_jsx(ScrollContainer, {
      className: classNames(theme.scrollContainer.base, (isDeviceMobile || !isDragging) && theme.scrollContainer.snap),
      draggingClassName: "cursor-grab",
      innerRef: carouselContainer,
      onEndScroll: handleDragging(false),
      onStartScroll: handleDragging(true),
      vertical: false,
      children: items === null || items === void 0 ? void 0 : items.map((item, index) => _jsx("div", {
        className: theme.item.wrapper,
        "data-active": activeItem === index,
        "data-testid": "carousel-item",
        children: item
      }, index))
    }), indicators && _jsx("div", {
      className: theme.indicators.wrapper,
      children: items === null || items === void 0 ? void 0 : items.map((_, index) => _jsx("button", {
        className: classNames(theme.indicators.base, theme.indicators.active[index === activeItem ? 'on' : 'off']),
        onClick: navigateTo(index),
        "data-testid": "carousel-indicator",
        "aria-label": `Slide ${index + 1}`
      }, index))
    }), items && _jsxs(_Fragment, {
      children: [_jsx("div", {
        className: theme.root.leftControl,
        children: _jsx("button", {
          className: "group",
          "data-testid": "carousel-left-control",
          onClick: navigateTo(activeItem - 1),
          type: "button",
          "aria-label": "Previous slide",
          children: leftControl ? leftControl : _jsx(DefaultLeftControl, {})
        })
      }), _jsx("div", {
        className: theme.root.rightControl,
        children: _jsx("button", {
          className: "group",
          "data-testid": "carousel-right-control",
          onClick: navigateTo(activeItem + 1),
          type: "button",
          "aria-label": "Next slide",
          children: rightControl ? rightControl : _jsx(DefaultRightControl, {})
        })
      })]
    })]
  }));
};
const DefaultLeftControl = () => {
  const theme = useTheme().theme.carousel;
  return _jsx("span", {
    className: theme.control.base,
    children: _jsx(HiOutlineChevronLeft, {
      className: theme.control.icon
    })
  });
};
const DefaultRightControl = () => {
  const theme = useTheme().theme.carousel;
  return _jsx("span", {
    className: theme.control.base,
    children: _jsx(HiOutlineChevronRight, {
      className: theme.control.icon
    })
  });
};
Carousel.displayName = 'Carousel';